"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypeContent = void 0;
var ETypeContent;
(function (ETypeContent) {
    ETypeContent[ETypeContent["IMAGE"] = 0] = "IMAGE";
    ETypeContent[ETypeContent["VIDEO"] = 1] = "VIDEO";
})(ETypeContent || (ETypeContent = {}));
exports.ETypeContent = ETypeContent;
